module.exports = __webpack_public_path__ + "img/end-screen.37925119.svg";